import { Select, MenuItem } from "@material-ui/core";
import { Field, useFormikContext } from "formik";

import { CaseDataResponse } from "../../../types/CaseTypes";
import { useCaseViewStyle } from "../../../components/CaseView/useCaseViewStyle";
import FMUInputField from "../../../components/shared/FormIkMUFormComponent/FMUInputField";
import FMUSelect from "../../../components/shared/FormIkMUFormComponent/FMUSelect";
import {
  getCaseType,
  getEvents,
} from "../../../components/shared/helpers/helper";
import { useStore } from "../../../context/StoreContext";
import { Typography } from "@mui/material";
import DescriptionOutlinedIcon from "@mui/icons-material/DescriptionOutlined";

const caseTypes = getCaseType();

function CaseInformationSection() {
  const classes = useCaseViewStyle();
  const { users } = useStore();
  const { values, setFieldValue } = useFormikContext<CaseDataResponse>();
  const isBusiness = values.case_detail.case_details.Subjects_information.some(
    (s) =>
      s.subject_id === values.case_detail.primary_subject &&
      s.subject_type === "business"
  );

  return (
    <div className={classes.leftTop}>
      <div className={classes.leftInformationDiv}>
        <div className={classes.cardHead}>
          <span className={classes.cardHeadIcon}>
            <DescriptionOutlinedIcon />
          </span>
          <h5 className={classes.tabHeading}>Case Information</h5>
        </div>
        <div className={classes.infoContainer}>
          <div className={classes.cardContentContainer}>
            <div className={classes.labelContainer}>
              <Typography variant={"h6"} className={classes.label}>
                Case type
              </Typography>
            </div>
            <Field
              name="case_detail.case_details.case_information.case_type"
              className={classes.formikInput}
              disableUnderline={true}
              options={caseTypes}
              component={FMUSelect}
            />
          </div>

          <div className={classes.cardContentContainer}>
            <div className={classes.labelContainer}>
              <Typography variant={"h6"} className={classes.label}>
                User name
              </Typography>
            </div>
            <Select
              className={classes.formikInput}
              disableUnderline
              value={
                values.case_detail.case_details.assigment_information
                  .investigator_name
              }
              onChange={(e) => {
                setFieldValue(
                  "case_detail.case_details.assigment_information.investigator_name",
                  e.target.value as string,
                  false
                );
              }}
            >
              {users.map((user, index) => (
                <MenuItem key={index} value={user}>
                  {user}
                </MenuItem>
              ))}
            </Select>
          </div>

          <div
            className={`${classes.cardContentContainer} ${classes.fieldWide}`}
          >
            <div className={classes.labelContainer}>
              <Typography variant={"h6"} className={classes.label}>
                {isBusiness ? "Business Name" : "Subject Name"}
              </Typography>
            </div>
            {/* <span className={`${classes.label} ${classes.fieldPaddingRight}`}>
              {subjectName}
            </span> */}
            <span style={{ display: "flex", gap: "8px" }}>
              <Field
                name="case_detail.case_details.case_information.subject_first_name"
                className={classes.formikInput}
                disableUnderline={true}
                type="text"
                component={FMUInputField}
              />
              {!isBusiness && (
                <Field
                  name="case_detail.case_details.case_information.subject_last_name"
                  className={classes.formikInput}
                  disableUnderline={true}
                  type="text"
                  component={FMUInputField}
                />
              )}
            </span>
          </div>

          <div
            className={`${classes.cardContentContainer} ${classes.fieldWide}`}
          >
            <div className={classes.labelContainer}>
              <Typography variant={"h6"} className={classes.label}>
                Subject Property
              </Typography>
            </div>
            <Field
              name="case_detail.case_details.case_information.subject_property_address"
              className={classes.formikInput}
              disableUnderline={true}
              type="text"
              component={FMUInputField}
            />
          </div>

          <div className={classes.cardContentContainer}>
            <div className={classes.labelContainer}>
              <Typography variant={"h6"} className={classes.label}>
                Foreclosure sale date
              </Typography>
            </div>
            <Field
              name="case_detail.case_details.case_information.sale_date"
              className={classes.formikInput}
              disableUnderline={true}
              type="date"
              component={FMUInputField}
            />
          </div>

          <div className={classes.cardContentContainer}>
            <div className={classes.labelContainer}>
              <Typography variant={"h6"} className={classes.label}>
                Event
              </Typography>
            </div>
            <Field
              name="case_detail.case_details.assigment_information.event"
              className={classes.formikInput}
              disableUnderline={true}
              options={getEvents()}
              component={FMUSelect}
            />
          </div>

          <div className={classes.cardContentContainer}>
            <div className={classes.labelContainer}>
              <Typography variant={"h6"} className={classes.label}>
                Date referred
              </Typography>
            </div>
            <Field
              name="case_detail.case_details.case_information.date_referred"
              className={classes.formikInput}
              disableUnderline={true}
              type="date"
              component={FMUInputField}
            />
          </div>

          <div className={classes.cardContentContainer}>
            <div className={classes.labelContainer}>
              <Typography variant={"h6"} className={classes.label}>
                Due date
              </Typography>
            </div>
            <Field
              name="case_detail.case_details.case_information.due_date"
              className={classes.formikInput}
              disableUnderline={true}
              type="date"
              component={FMUInputField}
            />
          </div>

          <div className={classes.cardContentContainer}>
            <div className={classes.labelContainer}>
              <Typography variant={"h6"} className={classes.label}>
                Reopened date
              </Typography>
            </div>
            <Field
              name="case_detail.case_details.case_information.reopened_date"
              className={classes.formikInput}
              disableUnderline={true}
              type="date"
              component={FMUInputField}
            />
          </div>

          <div className={classes.cardContentContainer}>
            <div className={classes.labelContainer}>
              <Typography variant={"h6"} className={classes.label}>
                Final report sent date
              </Typography>
            </div>
            <Field
              name="case_detail.case_details.case_information.final_report_send_date"
              className={classes.formikInput}
              disableUnderline={true}
              type="date"
              component={FMUInputField}
            />
          </div>

          <div className={classes.cardContentContainer}>
            <div className={classes.labelContainer}>
              <Typography variant={"h6"} className={classes.label}>
                Invoiced date
              </Typography>
            </div>
            <Field
              name="case_detail.case_details.case_information.invoice_date"
              className={classes.formikInput}
              disableUnderline={true}
              type="date"
              component={FMUInputField}
            />
          </div>

          <div className={classes.cardContentContainer}>
            <div className={classes.labelContainer}>
              <Typography variant={"h6"} className={classes.label}>
                Follow up date
              </Typography>
            </div>
            <Field
              name="case_detail.case_details.case_information.follow_up"
              className={classes.formikInput}
              disableUnderline={true}
              type="date"
              component={FMUInputField}
            />
          </div>

          <div
            className={`${classes.cardContentContainer} ${classes.fieldWide}`}
          >
            <div className={classes.labelContainer}>
              <Typography variant={"h6"} className={classes.label}>
                Status
              </Typography>
            </div>
            <Select
              className={classes.formikInput}
              disableUnderline
              value={values.case_detail.status}
              onChange={(e) => {
                setFieldValue(
                  "case_detail.status",
                  e.target.value as string,
                  false
                );
              }}
            >
              <MenuItem value="active">Active</MenuItem>
              <MenuItem value="inactive">InActive</MenuItem>
            </Select>
          </div>
        </div>
      </div>
    </div>
  );
}

export default CaseInformationSection;
